import { Backpack } from "lucide-react";

const dayWords = (iso) =>
  new Date(`${iso}T12:00:00`).toLocaleDateString(undefined, { weekday: "long", day: "numeric", month: "short" });

export const PackingNudge = ({ data, accent }) => {
  if (!data?.items?.length) return null;
  return (
    <div className="mt-5 rounded-2xl border border-white/10 bg-panel p-4" data-testid="packing-nudge">
      <div className="flex flex-wrap items-center gap-3">
        <p className="inline-flex items-center gap-2 text-[11px] uppercase tracking-widest" style={{ color: accent }}>
          <Backpack className="h-3.5 w-3.5" /> What to take {dayWords(data.day)}
        </p>
        {data.plans?.length > 0 && (
          <span className="text-xs text-ink-soft" data-testid="packing-plans">
            for {data.plans.slice(0, 3).join(", ")}
            {data.plans.length > 3 ? ` +${data.plans.length - 3} more` : ""}
          </span>
        )}
      </div>
      <div className="mt-2 flex flex-wrap gap-1.5">
        {data.items.map((item) => (
          <span
            key={item.thing}
            data-testid={`packing-item-${item.thing.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            className="rounded-full border border-white/10 bg-page px-3 py-1.5 text-xs"
          >
            <span className="font-semibold">{item.thing}</span>
            <span className="text-ink-soft"> — {item.why}</span>
          </span>
        ))}
      </div>
    </div>
  );
};
